import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import ConsultationOverlay from "./ConsultationOverlay";
import { SERVICES } from "../../data/services";

const navLinkClass = ({ isActive }) =>
  `text-sm font-medium transition-colors duration-200 ${
    isActive
      ? "text-brand-light"
      : "text-slate-700 hover:text-brand-light"
  }`;

const mobileLinkClass = ({ isActive }) =>
  `px-3 py-2.5 rounded-lg text-base font-medium transition-colors ${
    isActive
      ? "bg-blue-50 text-brand-light"
      : "text-slate-700 hover:bg-slate-50 hover:text-brand-light"
  }`;

const Header = () => {
  const [ismobile, setismobile] = useState(false);
  const [dropdwon, setdropdown] = useState(false);
  const [mobiledrop, setmobiledrop] = useState(false);
  const [showConsultationOverlay, setShowConsultationOverlay] = useState(false);

  const closeMobileMenu = () => setismobile(false);

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-md border-b border-slate-100 shadow-sm">
      <div className="layout-container">
        <nav className="flex items-center justify-between h-16 lg:h-[4.5rem] gap-4">
          <NavLink to="/" title="Ever Sky Overseas" className="flex-shrink-0" onClick={closeMobileMenu}>
            <img
              className="h-10 sm:h-11 lg:h-12 w-auto object-contain"
              src={logo}
              alt="Ever Sky Overseas"
            />
          </NavLink>

          <button
            type="button"
            aria-label="Toggle menu"
            className="inline-flex p-2.5 text-slate-700 rounded-xl lg:hidden hover:bg-slate-100 transition-colors"
            onClick={() => setismobile(!ismobile)}
          >
            {ismobile ? (
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
              </svg>
            )}
          </button>

          <div className="hidden lg:flex lg:items-center lg:ml-auto lg:gap-7">
            <NavLink to="/" className={navLinkClass}>Home</NavLink>
            <NavLink to="/about" className={navLinkClass}>About</NavLink>
            <div className="relative" onMouseEnter={() => setdropdown(true)} onMouseLeave={() => setdropdown(false)}>
              <NavLink to="/services" className={navLinkClass}>
                <span className="inline-flex items-center gap-1">
                  Services
                  <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={dropdwon ? "M5 15l7-7 7 7" : "M19 9l-7 7-7-7"} />
                  </svg>
                </span>
              </NavLink>
              {dropdwon && (
                <div className="absolute left-1/2 -translate-x-1/2 top-full pt-3 w-[640px]">
                  <div className="bg-white border border-slate-100 shadow-card-hover rounded-2xl p-5 grid grid-cols-2 gap-2">
                    {SERVICES.map((service) => (
                      <NavLink
                        key={service.id}
                        to={service.route}
                        className="block p-3 rounded-xl hover:bg-gradient-to-br hover:from-blue-50 hover:to-teal-50 transition-all group"
                        onClick={() => setdropdown(false)}
                      >
                        <h3 className="font-semibold text-slate-800 text-sm group-hover:text-brand-light">
                          {service.icon} {service.title}
                        </h3>
                        <p className="text-slate-500 text-xs mt-1 line-clamp-2">{service.shortDescription}</p>
                      </NavLink>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <NavLink to="/pricing" className={navLinkClass}>Pricing</NavLink>
            <NavLink to="/resources" className={navLinkClass}>Resources</NavLink>
            <NavLink to="/contact" className={navLinkClass}>Contact</NavLink>
            <button
              type="button"
              onClick={() => setShowConsultationOverlay(true)}
              className="btn-primary whitespace-nowrap !py-2.5 !px-5"
            >
              Free Consultation
            </button>
          </div>
        </nav>

        {ismobile && (
          <nav className="lg:hidden pb-4 border-t border-slate-100 animate-in">
            <div className="flex flex-col pt-3 space-y-1">
              <NavLink to="/" onClick={closeMobileMenu} className={mobileLinkClass}>Home</NavLink>
              <NavLink to="/about" onClick={closeMobileMenu} className={mobileLinkClass}>About</NavLink>
              <button
                type="button"
                onClick={() => setmobiledrop(!mobiledrop)}
                className="px-3 py-2.5 text-base font-medium text-slate-700 text-left flex items-center justify-between rounded-lg hover:bg-slate-50"
              >
                Services
                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={mobiledrop ? "M5 15l7-7 7 7" : "M19 9l-7 7-7-7"} />
                </svg>
              </button>
              {mobiledrop && (
                <div className="ml-3 pl-3 border-l-2 border-brand-light/30 flex flex-col space-y-1 py-1">
                  {SERVICES.map((service) => (
                    <NavLink
                      key={service.id}
                      to={service.route}
                      onClick={closeMobileMenu}
                      className="py-2 text-sm text-slate-600 hover:text-brand-light"
                    >
                      {service.title}
                    </NavLink>
                  ))}
                </div>
              )}
              <NavLink to="/pricing" onClick={closeMobileMenu} className={mobileLinkClass}>Pricing</NavLink>
              <NavLink to="/resources" onClick={closeMobileMenu} className={mobileLinkClass}>Resources</NavLink>
              <NavLink to="/contact" onClick={closeMobileMenu} className={mobileLinkClass}>Contact</NavLink>
              <button
                type="button"
                onClick={() => { setShowConsultationOverlay(true); closeMobileMenu(); }}
                className="btn-primary mt-2 mx-1 w-full"
              >
                Free Consultation
              </button>
            </div>
          </nav>
        )}
      </div>
      {showConsultationOverlay && (
        <ConsultationOverlay onClose={() => setShowConsultationOverlay(false)} />
      )}
    </header>
  );
};

export default Header;
